import React, { useState } from 'react';
import './About.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleLeft,faCircleRight } from "@fortawesome/free-solid-svg-icons";
const About = () => {
    const images = [
        "images/about.png",
        "images/bg.png",
        "images/flower.png",
      ];
    
      const [currentImageIndex, setCurrentImageIndex] = useState(0);
    
      const handlePrev = () => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
      };
    
      const handleNext = () => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
      };
    
  return (
    <div className='about py-5 px-2 my-5'>
    <div className="container-fluid">
        <div className="row align-items-center">
            <div className="col-md-6">
                <div className="d-flex align-items-center gap-3">
                <FontAwesomeIcon
                icon={faCircleLeft}
                className="fa-3x hovers secondary-color"
                onClick={handlePrev} 
              />
              <img
                src={images[currentImageIndex]} 
                className="about-img rounded-5"
                alt="About"
              />
              <FontAwesomeIcon
                icon={faCircleRight}
                className="fa-3x hovers main-color"
                onClick={handleNext} 
              />
                </div>
            </div>
            <div className="col-md-6">
                <div className="d-flex flex-column gap-4 align-items-start desc-container about-desc py-5 px-4 mx-auto rounded-5">
                <div className="d-flex align-items-center gap-3">
                    <img src="images/Group-1.png" alt="" />
                    <img src="images/About Us.png" alt="" />
                </div>
                <p className=' m-0 about-text'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type </p>
                <div className="main-bg hovers px-3 py-2 text-white rounded-pill">See More</div>
                </div>
            </div>
        </div>
    </div>
    </div>
  )
}

export default About
